<template>
	<div class="log" v-loading="loading">
		<div class="flex top10 bottom10">
			<el-input v-model="name" style="width: 180px;" placeholder="用户名"></el-input>
			<el-date-picker class="left10 right10" v-model="time" type="daterange" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
			<el-button @click="getAll()" type="primary">搜索</el-button>
		</div>
		<el-table :data="data" style="width: 100%" border>
			<el-table-column prop="username" label="用户名"></el-table-column>
			<el-table-column prop="ipaddr" label="ip地址"></el-table-column>
			<el-table-column prop="browser" label="浏览器"></el-table-column>
			<el-table-column prop="os" label="操作系统"></el-table-column>
			<el-table-column label="状态">
				<template slot-scope="{row}">{{row.status*1?"登录失败":"登录成功"}}</template>
			</el-table-column>
			<el-table-column label="登录时间">
				<template slot-scope="{row}">{{setTime(row.loginTime)}}</template>
			</el-table-column>
		</el-table>
		<el-pagination :page-sizes="[10, 20, 30, 40]" :page-size="10" layout="total, sizes, prev, pager, next, jumper" :total="count"
		 @size-change="sizeChange" @current-change="currentChange">
		</el-pagination>
		<el-dialog title="提示" :visible.sync="show" width="30%" :close-on-click-modal="false" :modal-append-to-body="false">
			<h3>确定要清空所有日志吗?</h3>
			<span slot="footer" class="dialog-footer">
				<el-button @click="show = false" size="small">取 消</el-button>
				<el-button @click="mov" size="small" :disabled="!show">确 定</el-button>
			</span>
		</el-dialog>
	</div>

</template>

<script>
	export default {
		data() {
			return {
				loading: false,
				data: [],
				time: [],
				count: null,
				page: 1,
				size: 10,
				show: false,
				name:null
			}
		},
		methods: {
			getAll() {
				let startTime = null
				let endTime = null
				if(this.time.length==2){
					startTime = new Date(this.time[0]).getTime()
					endTime = new Date(this.time[1]).getTime()
				}
				this.loading = true;
				this.$http.post("/api/monitor/logininfor/findAll", {
					currentPage: this.page,
					pageSize: this.size,
					name:this.name,
					startTime,
					endTime
				}).then(res => {
					this.data = res.data.data.items
					this.count = res.data.data.totalNum
					this.loading = false;
				})
			},
			setObj(val) {
				this.obj = val
			},
			currentChange(val) {
				this.getAll(val - 1, this.size)
				this.page = val
			},
			sizeChange(val) {
				this.getAll(this.page - 1, val)
				this.size = val
			},
			mov() {
				this.show = false;
				this.$http.delete("/api/api/logs/del/info").then(res => {
					this.$message.success("日志已清空")
					this.getAll();
				})
			}
		},
		mounted() {
			this.getAll();
		}
	}
</script>

<style scoped="scoped">
	.log {
		padding: 0 10px;
	}
</style>
